<template>
  <v-container
    fluid
    fill-height
    class="home-hero"
    id="homecontainer"
    height="1000px"
  >
    <v-layout justify-center align-center column pa-5>
      <div class="banner-text display-1 font-weight-black white--text text-center">
        리모렌트카
      </div>
      <div class="banner-text display-4 font-weight-black white--text text-center mb-3">
        중고차 장기
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "UsedcarBanner",
  data: () => ({})
};
</script>

<style scoped>
.home-hero {
  background: url("../../assets/banners/usedcar.jpg");
  background-size: cover;
  height: 300px !important;
  padding: 0;
}

.banner-text {
  text-shadow: 2px 2px 8px black;
}
</style>
